module.exports = __webpack_public_path__ + "img/333_08.2b0d0e48.gif";